export default __webpack_public_path__ + "static/media/6.3b1dd3a6.png";